<template>
    <div class="video-show">
        <!-- <video id="myVideo" class="video-js" style="width: 100%;height: 100%;object-fit: fill">
            <source src="http://ah.download.ahedu.cn/f/files/f63dce62b37d45489b9ad604db593bb0_wmv.mp4" type="video/mp4">
        </video> -->

        <video name="media" controls="controls" width="100%" height="100%" controlslist="nodownload">
            <source :src="source" type="video/mp4">
        </video>
    </div>
</template>
<script>
    /* eslint-disable */
    export default {
        name: "VideoShow",
        data() {
            return {}
        },
        mounted() {
            this.$parent.$refs.showRef.style.overflow = 'hidden'
            // this.initVideo()
        },
        methods: {
            initVideo() {
                //初始化视频方法
                let myPlayer = this.$video(myVideo, {
                    //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                    controls: true,
                    //自动播放属性,muted:静音播放
                    autoplay: "muted",
                    //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                    preload: "auto",
                    fluid: true, // 宽高自适应
                });
            }
        },
        props: {
            source: {
                type: String,
                default: ''
            },
        }
    }
</script>

<style scoped>
    .video-show {
        height: 100%;
    }
</style>
